import { Body, Controller, Param, Post, BadRequestException } from '@nestjs/common'
import axios from 'axios'
import { Sequelize } from 'sequelize-typescript'
import { WebhookAplicacionService } from '../../../../plataforma/services/aplicacion.server.services'

@Controller('webhook/facebook/dispatcher/:apiKey')
export class WebhookMensajeController {
  cancelar
  constructor(private aplicacionService: WebhookAplicacionService, private sequelize: Sequelize) {
    this.cancelar = false
  }

  @Post()
  async post(@Param('apiKey') apiKey: string, @Body() data: any) {
    if (!apiKey) {
      ///return res.status(500).json({ error: true })
      throw new Error(JSON.stringify({ error: true }))
    }
    const aplicacion = await this.aplicacionService.obtenerAplicacionApi(apiKey)

    console.log(data.message)
    console.log(aplicacion, 'aplicacion')

    const message = {}
    if (data.message.attachments.length) {
      message['attachment'] = {
        type: data.message.attachments[0].type,
        payload: {
          url: data.message.attachments[0].url,
        },
      }
    } else {
      message['text'] = data.message.text.body
    }

    console.log(message, 'data final')

    await axios
      .post(`https://graph.facebook.com/me/messages?access_token=${aplicacion.token}`, {
        messaging_type: 'RESPONSE',
        recipient: {
          id: data.senderId,
        },
        message,
      })
      .then((res) => {
        console.log(`statusCode: ${res.status}`)
        console.log(res)
      })
      .catch((error) => {
        throw new BadRequestException({
          code: error.response.data.error.code,
          type: error.response.data.error.type,
          message: error.response.data.error.message,
        })
      })

    return { status: 'true' }
  }
}
